import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { PfizerPreTaskSafetyPlan } from '../pfizer-pre-task-safety-plan.model';
import { GeneralFormData } from '../../general-form-data.model';
import { FormStep } from '../../form-steps.interface';
import { parseLocalDate } from '../../../../utils/date-time-formatter';

export class PfizerPreTaskTemplate extends PfizerPreTaskSafetyPlan {
    templateTitle: string = '';
    isActive: boolean = true;
    sourceDocumentId?: string; // Optional - for audit trail of where template came from

    constructor(data?: Partial<PfizerPreTaskTemplate>) {
        super(data);
        if (data) {
            this.templateTitle = data.templateTitle || '';
            this.isActive = data.isActive !== undefined ? data.isActive : true;
            this.sourceDocumentId = data.sourceDocumentId
        }
    }

    // Override getFormInfo if you need different metadata for templates
    static override getFormInfo(): GeneralFormData {
        const baseInfo = PfizerPreTaskSafetyPlan.getFormInfo();
        return {
            ...baseInfo,
            formType: 'pfizer-pre-task-safety-plan-template',
            formTitle: 'Pfizer Pre-Task Safety Plan Template',
            // No need for attachment requirements in template creation
            formAttachmentRequirements: {}
        };
    }

    // Templates don't need steps - just inherit field mappings
    static override getFieldMappings(): Record<string, string> {
        return {
            ...PfizerPreTaskSafetyPlan.getFieldMappings(),
            templateTitle: "Template Name",
            isActive: "Active",
            createdBy: "Created By",
            createdDate: "Created Date",
            sourceDocumentId: "Source Document ID"
        };
    }

    // Remove getFormSteps() - templates don't need it
    // Or explicitly return empty array if your code expects it
    static override getFormSteps(): FormStep[] {
        return [];
    }
}